import { createFileRoute } from '@tanstack/react-router'
import { PortalLanding } from '../../features/portal/landing'

/** Magic-link landing: `/portal/link#t=<token>` (the token is read from the fragment, then removed). */
export const Route = createFileRoute('/portal/link')({
  component: PortalLanding,
})
